import { usePermissions } from '@/context/PermissionsContext';

interface UseHasPermissionProps {
  action: string | string[];
  resource: string;
  isAllCompaniesRequired?: boolean;
}

interface Permission {
  action: string;
  resource: string;
  hasAllCompaniesAssigned: boolean;
}

interface HasPermission {
  hasPermission: boolean;
  isLoading: boolean;
}

const useHasPermission = ({
  action,
  resource,
  isAllCompaniesRequired,
}: UseHasPermissionProps): HasPermission => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading || !permissions) {
    return { hasPermission: false, isLoading };
  }

  const actions = Array.isArray(action) ? action : [action];

  const hasPermission = permissions.some((permission: Permission) => {
    return isAllCompaniesRequired
      ? actions.includes(permission.action) &&
          permission.resource === resource &&
          permission.hasAllCompaniesAssigned
      : actions.includes(permission.action) && permission.resource === resource;
  });

  return { hasPermission, isLoading };
};

export default useHasPermission;
